import React from 'react'
import { useTranslation } from "react-i18next";
import { Grid, SvgIcon } from '@material-ui/core';
import { TooltipHLPure } from '../../../pures';

export const RegisterFormHeading = (props) => {
    const { t, ready } = useTranslation();

    if (!ready) {
        return null;
    }

    return <Grid item xs={12} className='loginForm-heading'>
        <button onClick={props.handleBack} className='loginForm-arrowBackBtn' aria-label='Back'>
            <i className="fas fa-solid fa-arrow-left"></i>
        </button>
        <h2>{t("loginView.registerFormTitle")}</h2>
    </Grid>
}

function RegisterForm(props) {
    const { t, ready } = useTranslation();

    if (!ready) {
        return null;
    }

    return (
        <>
            <Grid item xs={12} container className='loginForm-container'>
                {/* EMAIL FIELD */}
                <Grid item xs={12} className="loginForm-input-container">
                    <label htmlFor="newEmail" className="loginForm-input-label">{t("loginView.placeholderEmail")}</label>
                    <div className='loginForm-input-wrapper'>
                        <input
                            type="text"
                            className="loginForm-input-field"
                            id="newEmail"
                            value={props.newEmail}
                            onChange={(e) => props.onHandleGeneralChange(e)}
                            onKeyDown={(e) =>
                                props.onHandleSignUpKeypress(e)
                            }
                        />
                    </div>
                </Grid>

                {/* PASSWORD FIELD */}
                <Grid item xs={12} className="loginForm-input-container">
                    <div className='loginForm-label-tooltip'>
                        <label htmlFor="newPassword" className="loginForm-input-label">{t("loginView.placeholderPassword")}</label>
                        <TooltipHLPure
                            titleTooltip={t("loginView.passwordTooltipTitle")}
                            freeContent={(
                                <ul className='loginForm-label-tooltip-content'>
                                    <li>{t("loginView.passwordTooltipDesc1")}</li>
                                    <li>{t("loginView.passwordTooltipDesc2")}</li>
                                    <li>{t("loginView.passwordTooltipDesc3")}</li>
                                    <li>{t("loginView.passwordTooltipDesc4")}</li>
                                </ul>
                            )}
                            informationIcon
                        />
                    </div>
                    <div className='loginForm-input-wrapper'>
                        <input
                            className="loginForm-input-field loginForm-input-password"
                            type="password"
                            id="newPassword"
                            autocomplete="new-password"
                            onChange={(e) => props.onHandleGeneralChange(e)}
                            onKeyDown={(e) =>
                                props.onHandleSignUpKeypress(e)
                            }
                        />

                        {/* EYE ICON */}
                        <button className='loginForm-showPasswordBtn' onClick={props.onHandleShowPasswordRegister}>
                            <SvgIcon
                                className={`loginForm-input-icon ${props.loginShowPasswordRegisterIcon}`}
                            >
                                <path d="M0 0h24v24H0V0z" fill="none" />
                                <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z" />
                            </SvgIcon>
                        </button>
                    </div>
                </Grid>

                {/* CONFIRM PASSWORD FIELD */}
                <Grid item xs={12} className="loginForm-input-container">
                    <label htmlFor="repeatNewPassword" className="loginForm-input-label">{t("loginView.placeholderConfirmPassword")}</label>
                    <div className='loginForm-input-wrapper'>
                        <input
                            className="loginForm-input-field loginForm-input-password"
                            type="password"
                            id="repeatNewPassword"
                            autocomplete="new-password"
                            onChange={(e) => props.onHandleGeneralChange(e)}
                            onKeyDown={(e) =>
                                props.onHandleSignUpKeypress(e)
                            }
                        />

                        {/* EYE ICON */}
                        <button className='loginForm-showPasswordBtn' onClick={props.onHandleShowPasswordRepeatRegister}>
                            <SvgIcon
                                className={`loginForm-input-icon ${props.loginShowPasswordRepeatRegisterIcon}`}
                            >
                                <path d="M0 0h24v24H0V0z" fill="none" />
                                <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z" />
                            </SvgIcon>
                        </button>
                    </div>
                </Grid>

                <Grid item xs={12}>
                    <p className='loginForm-registrationTerms'>{t("loginView.textIfYouSuscribeYouMustAcept")} <a onClick={() => props.openModalTermsCond(true)}>{t("loginView.textTermsAndConditions")}</a> {t("loginView.textAsWellThe")} <a onClick={() => props.openModalPolicityPrivacy(true)}>{t("loginView.textPolicityPrivacy")}</a></p>
                </Grid>
            </Grid>

            {/* ACTIONS */}
            <Grid item xs={12}>
                <button
                    className="loginForm-primaryBtn"
                    onClick={(e) => props.onHandleSignUp(e)}
                >
                    {props.loading
                        ? <span className="preloader"></span>
                        : t("loginView.buttonRegister")
                    }
                </button>
            </Grid>
        </>
    )
}

export default RegisterForm